import { useRunArtifactsManifest } from '../api/runFiles';
import { LinkRow } from './LinkRow';

// Compact links-only artifact list for the job drawer (A1EE-411). Renders nothing
// for non-terminal runs (the manifest may not exist yet — and a premature fetch
// would cache an empty manifest; see useRunArtifactsManifest) and nothing on
// error/empty: the drawer is a summary surface, silence beats noise.
export function RunArtifactLinks({
  jobId,
  runId,
  terminal,
}: {
  jobId: string;
  runId: string;
  terminal: boolean;
}) {
  // Hooks must run unconditionally; gate the fetch via the `enabled` arg so a
  // non-terminal run never hits the manifest endpoint (no sticky-empty cache).
  const query = useRunArtifactsManifest(jobId, runId, terminal);
  if (!terminal || query.isPending || query.isError || query.data.artifacts.length === 0) {
    return null;
  }
  return (
    <ul className="space-y-1.5 text-sm">
      {query.data.artifacts.map((a, i) => (
        <LinkRow key={`${a.kind}:${a.url}:${i}`} artifact={a} />
      ))}
    </ul>
  );
}
